import { render, staticRenderFns } from "./order-constructopr-main.vue?vue&type=template&id=f1fa66a2&"
import script from "./order-constructopr-main.vue?vue&type=script&lang=ts&"
export * from "./order-constructopr-main.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports